import { render } from "./SubservicesHeader.vue?vue&type=template&id=00bf186e&ts=true"
import script from "./SubservicesHeader.vue?vue&type=script&lang=ts"
export * from "./SubservicesHeader.vue?vue&type=script&lang=ts"

import "./SubservicesHeader.vue?vue&type=style&index=0&id=00bf186e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBreadcrumbs,QBreadcrumbsEl,QBtn});
